/* unplugin-vue-components disabled */import { render } from "./KilaKilaWifeCover.vue?vue&type=template&id=6349be9f&scoped=true"
import script from "./KilaKilaWifeCover.vue?vue&type=script&lang=js"
export * from "./KilaKilaWifeCover.vue?vue&type=script&lang=js"

import "./KilaKilaWifeCover.vue?vue&type=style&index=0&id=6349be9f&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6349be9f"]])

export default __exports__